export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="white"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.64453 9.14631L9.64336 9.14514L5.16016 4.66194L6.15642 3.66567L10.6396 8.14887L11.6359 9.14514L11.6347 9.14631L11.6359 9.14748L10.6396 10.1437L6.15642 14.627L5.16016 13.6307L9.64336 9.14748L9.64453 9.14631Z"
        fill="white"
      />
    </svg>
  );
};
